module.exports = __webpack_public_path__ + "static/media/collectibles_gem.77c73a7e.png";